<template>
    <div class="web">
        <Header :type="'contacto'"></Header>
        <main class="contacto" style="background: rgb(238, 238, 238)">
            <div class="hero">
                <div class="container text-center">
                    <div class="row mb-5">
                        <div class="col-12">
                            <h3 class="text-black">Complete el formulario de contacto <br />
                                y nos comunicaremos contigo</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 offset-3">
                            <form action="" method="POST">
                                <div class="row mb-4">
                                    <div class="form-group text-start col-6">
                                        <label class="text-black" for="nombre">Nombre <span class="text-danger">*</span></label>
                                        <input type="text" name="nombre" id="nombre" class="form-control">
                                    </div>
                                    <div class="form-group text-start col-6">
                                        <label class="text-black" for="pais">País <span class="text-danger">*</span></label>
                                        <input type="text" name="pais" id="pais" class="form-control">
                                    </div>
                                </div>
                                <div class="row mb-4">
                                    <div class="form-group text-start col-6">
                                        <label class="text-black" for="email">E-mail <span class="text-danger">*</span></label>
                                        <input type="email" name="email" id="email" class="form-control" novalidate>
                                    </div>
                                    <div class="form-group text-start col-6">
                                        <label class="text-black" for="tel">Tel. Contacto <span class="text-danger">*</span></label>
                                        <input type="tel" name="tel" id="tel" class="form-control">
                                    </div>
                                </div>
                                <div class="form-group text-start col-12 mb-4">
                                    <label class="text-black" for="mensaje">Mensaje <span class="text-danger">*</span></label>
                                    <textarea name="mensaje" id="mensaje" class="form-control"></textarea>
                                </div>
                                <div class="form-group text-end">
                                    <input type="submit" value="Enviar" class="btn btn-orange btn-lg">
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        
    </div>
  </template>
    
    <script>
    import { mapState } from 'vuex'
    import Header from '@/components/Header'
    export default {
      computed:{
        ...mapState(['urlWeb'])
    },
      name: 'Contacto',
      components:{
        Header
    },
      data () {
        return {
        }
      }
    }
    </script>


// WEBPACK FOOTER //
// src/views/Home/Contacto.vue